import api from '@/api'
/* 专家用接口列表 */

/* 专家绑定考核阶段管理 */
// 获取绑定考核阶段的专家列表--分页
export function getBoundExportsListForStage(params) {
  return api({
    url: '/expertToStage/expertBoundStagePage',
    method: 'GET',
    params
  })
}

// 解绑专家与考核阶段
export function deleteExportForStage(params) {
  const { expertUuid, stageUuid } = params;
  return api({
    url: `/expertToStage/expertDelete/${expertUuid}/${stageUuid}`,
    method: "DELETE",
  })
}

// 获取未绑定考核阶段的专家列表--不可分页
export function getAllUnboundExportForStage(params) {
  return api({
    url: '/expertToStage/expertNotBoundStageList',
    method: 'GET',
    params
  })
}

// 批量绑定专家与考核阶段
export function postExportToStageGroup(data) {
  return api({
    url: '/expertToStage/expertToStageBatchAdd',
    method: "POST",
    data
  })
}

/* 专家绑定机构管理 */
// 获取专家绑定机构列表--分页
export function getExportForYouthPage(params) {
  return api({
    url: '/expertToYouth/expertBoundYouthPage',
    method: 'GET',
    params
  })
}

// 获取未绑定专家的机构列表
export function getExportsForYouth(params) {
  return api({
    url: '/expertToYouth/expertNotBoundYouthList',
    method: 'GET',
    params
  })
}

// 批量绑定专家与机构
export function postExportToYouthGroup(data) {
  return api({
    url: '/expertToYouth/expertToYouthBatchAdd',
    method: 'POST',
    data
  })
}

// 解绑专家与机构
export function deleteYouthForExport(data) {
  return api({
    url: '/expertToYouth/youthDelete',
    method: 'DELETE',
    data
  })
}

/* 专家绑定二级指标管理 */
// 批量绑定专家与二级指标
export function postTargetToExpert(data) {
  return api({
    url: '/expertToTargetSecondly/expertToTargetSecondlyBatchAdd',
    method: 'POST',
    data
  })
}

// 解绑专家与二级指标
export function deleteTargetToExpeert(data) {
  return api({
    url: '/expertToTargetSecondly/expertToTargetSecondlyDelete',
    method: 'DELETE',
    data
  })
}

/* 专家绑定耳机指标管理 */
// 获取专家绑定耳机指标列表 -- 分页
export function getExportForSecondTargetPage(params) {
  return api({
    url: '/expertToTargetSecondly/expertBoundTargetSecondlyPage',
    method: 'GET',
    params
  })
}

// 获取未绑定专家的二级指标列表
export function getSecondTargetForExpertList(params) {
  return api({
    url: '/expertToTargetSecondly/expertNotBoundTargetSecondlyList',
    method: 'GET',
    params
  })
}

// 批量绑定专家与二级指标
export function postSecondTargetForExpert(data) {
  return api({
    url: '/expertToTargetSecondly/expertToTargetSecondlyBatchAdd',
    method: 'POST',
    data
  })
}

// 解绑专家与二级指标
export function deleteSecondTargetForExpert(data) {
  return api({
    url: '/expertToTargetSecondly/expertToTargetSecondlyDelete',
    method: 'DELETE',
    data
  })
}


/* 专家角色用 */
// 列表-审核考核阶段-GET-可分页--专家调用
 export function getExpertAuditStagePage(params) {
    return api({
      url: '/jixiao/target/audit/getExpertAuditStagePage',
      method: 'GET',
      params
    })
 }

//  获取待审核青训中心、俱乐部列表-GET-可分页--专家调用
export function getExpertAuditYouthClubPage(params) {
  return api({
    url: '/jixiao/target/audit/expertAuditYouthAndClubPage',
    method: 'GET',
    params
  })
}

// 列表-绩效指标审核-GET-列表--专家调用
export function getExpertTargetAuditList(params) {
  return api({
    url: '/jixiao/target/audit/getExpertTargetAuditList',
    method: 'GET',
    params
  })
}

// 批量专家下载当前机构全部考核指标文件(zip)--专家调用
export function getAllFileForExpertDownload(params) {
  const { youthUuid, stageUuid } = params;
  return api({
    url: `/jixiao/target/audit/batchExpertDownloadTargetAllFileZip/${youthUuid}/${stageUuid}`,
    method: 'GET',
  })
}

/* 专家管理 */
// 添加专家
export function postExpert(data) {
  return api({
    url: '/expert/expertAdd',
    method: 'POST',
    data
  })
}
// 修改专家
export function putExpert(data) {
  return api({
    url: '/expert/expertEdit',
    method: 'PUT',
    data
  })
}

// 获取专家列表-GET-可分页--系统管理员/技术支持调用
export function getExpertPage(params) {
  return api({
    url: '/expert/expertPageSystem',
    method: 'GET',
    params
  })
}

// 获取专家列表-GET-可分页--系统管理员/技术支持调用
export function expertBoundFileZip(params) {
  const { uuid } = params;
  return api({
    url: `/expertToYouth/experBoundYouthAllFileZipUrl/${uuid}`,
    method: 'GET'
  })
}

export function getExportForBaseTypePage(params) {
  return api({
    url: '/expertToTargetSecondly/expertBoundTargetBaseTypePage',
    method: 'GET',
    params
  })
}
// 解绑专家与日常管理指标
export function deleteTargetToExpeertBaseType(data) {
  return api({
    url: '/expertToTargetSecondly/expertToTargetBaseTypeDelete',
    method: 'DELETE',
    data
  })
}
// 获取未绑定专家的日常管理指标列表
export function getBaseTypeTargetForExpertList(params) {
  return api({
    url: '/expertToTargetSecondly/expertNotBoundTargetBaseTypeList',
    method: 'GET',
    params
  })
}
// 批量绑定专家与二级指标
export function postBaseTypeTargetForExpert(data) {
  return api({
    url: '/expertToTargetSecondly/expertToTargetBaseTypeBatchAdd',
    method: 'POST',
    data
  })
}
